import { CSSProperties, ReactNode } from 'react';
import styled from 'styled-components';
import {
  CUSTOM_SVG_ICON_CLASS,
  Icon,
  IconSize,
  SvgIcon,
  isSVGIcon,
} from '@ardoq/icons';
import { MetamodelType } from '../state/types';
import { getMetamodelTypeColor } from './utils';

interface FontIconProps {
  iconId: string;
  style?: CSSProperties;
  iconSize: IconSize;
}

const getIconSize = ({ $iconSize }: { $iconSize: IconSize }) =>
  `${$iconSize}px`;

const FontAwesomeIconStyle = styled.i<{ $iconSize: IconSize }>`
  && {
    display: block;
    font-size: ${getIconSize};
    text-align: center;
  }
`;

const FontAwesomeIcon = ({ iconId, style, iconSize }: FontIconProps) => (
  <FontAwesomeIconStyle
    style={style}
    className={`fa fa-${iconId}`}
    $iconSize={iconSize}
  />
);

const MetamodelTypeIconWrapper = styled.div<{ $iconSize: IconSize }>`
  width: ${getIconSize};
  height: ${getIconSize};

  /* bpmn or archimate */
  .${CUSTOM_SVG_ICON_CLASS} {
    width: ${getIconSize};
    height: ${getIconSize};
  }

  img {
    width: ${getIconSize};
    height: ${getIconSize};
  }
`;

export const MetamodelTypeIcon = ({
  metamodelType,
  iconSize = IconSize.MEDIUM,
}: {
  metamodelType: MetamodelType;
  iconSize?: IconSize;
}) => {
  const { icon, image } = metamodelType;

  let content: ReactNode | null = null;
  if (image) {
    content = <Icon src={image} iconSize={iconSize} />;
  } else if (icon && isSVGIcon(icon)) {
    content = <SvgIcon iconId={icon} />;
  } else if (icon) {
    content = <FontAwesomeIcon iconId={icon} iconSize={iconSize} />;
  }

  return content ? (
    <MetamodelTypeIconWrapper
      $iconSize={iconSize}
      style={{ color: getMetamodelTypeColor(metamodelType) }}
    >
      {content}
    </MetamodelTypeIconWrapper>
  ) : null;
};
